/**
 * Created by Shiv Roy on 23/11/17.
 */
import {
  actionCreator,
  GET_APP_CONFIG_API, appConfigActionTypes, checkHttpStatus,
  IF_RECORD_EXIST,
  IF_RECORD_EXIST_MASTERDB,
  jsonApiHeader,
  POST_APP_CONFIG_API,
  showSuccessMessage,
  showErrorMessage,
} from './../constants';
import history from '../../../history';

export const checkFieldExistence = (data) => {
  // console.log('input.data...........',data)
  return (dispatch, getState) => {
    dispatch(actionCreator(appConfigActionTypes.field_exist_error.REQUEST));
    fetch(`${IF_RECORD_EXIST}`, {
      method: 'post',
      body: JSON.stringify(data),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('input.response...........',response)
        dispatch(actionCreator(appConfigActionTypes.field_exist_error.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error: ', error);
      });
  };
};


export const checkFieldExistenceInMasterDB = (data) => {
  // console.log('input.data...........',data)
  return (dispatch, getState) => {
    dispatch(actionCreator(appConfigActionTypes.field_exist_error.REQUEST));
    fetch(`${IF_RECORD_EXIST_MASTERDB}`, {
      method: 'post',
      body: JSON.stringify(data),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        //  console.log('input.response...........',response)
        dispatch(actionCreator(appConfigActionTypes.field_exist_error.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error: ', error);
      });
  };
};


export const clearFieldErrorArray = () => { //  Clear Field Array into store(reducer)
  return (dispatch, getState) => {
    dispatch(actionCreator(appConfigActionTypes.clear_field_exist_error.REQUEST));
    dispatch(actionCreator(appConfigActionTypes.clear_field_exist_error.SUCCESS));
  };
};

export const getAppConfigList = () => {
  return (dispatch, getState) => {
    dispatch(actionCreator(appConfigActionTypes.get_app_config.REQUEST));
    fetch(`${GET_APP_CONFIG_API}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(appConfigActionTypes.get_app_config.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error: get_app_config', error);
      });
  };
};

export const updateAppConfig = (data) => {
  // console.log('save--------', data);
  return (dispatch, getState) => {
    dispatch(actionCreator(appConfigActionTypes.post_app_config.REQUEST));
    fetch(`${POST_APP_CONFIG_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(data),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(appConfigActionTypes.post_app_config.SUCCESS, response));
        // let successMsg = 'Settings has been updated successfully';
        showSuccessMessage(response.message);
        history.push('/dashboard');
      })
      .catch(function(error) {
        console.log('error: post_app_config', error);
      });
  };
};


export const UpdateActiveStatus = (data) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(appConfigActionTypes.update_active_status.REQUEST));
    fetch(`${IF_RECORD_EXIST}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(appConfigActionTypes.update_active_status.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error: ', error);
      });
  };
};

export const getGeoLocation = () => {
  return (dispatch, getState) => {
    dispatch(actionCreator(appConfigActionTypes.get_GEO_Location.REQUEST));        
    const geolocation = navigator.geolocation;
    if (!geolocation) {      
      dispatch(actionCreator(appConfigActionTypes.get_GEO_Location.SUCCESS, null));
      showErrorMessage('Geolocation Not Supported');      
    }
   geolocation.getCurrentPosition((position) => {            
      //  console.log('position..........',position)
       dispatch(actionCreator(appConfigActionTypes.get_GEO_Location.SUCCESS, position));
    }, (error) => {      
      dispatch(actionCreator(appConfigActionTypes.get_GEO_Location.SUCCESS, null));
      showErrorMessage('Geolocation permission denied',error);      
    },
    //(error) => console.log(new Date(), error),
    {maximumAge:600000, timeout:600000, enableHighAccuracy: true}    
    );
  };
};

export const getGeoLocationClockIn = () => {
  return (dispatch, getState) => {
    dispatch(actionCreator(appConfigActionTypes.get_GEO_Location_ClockIn.REQUEST));        
    const geolocation = navigator.geolocation;
    if (!geolocation) {      
      dispatch(actionCreator(appConfigActionTypes.get_GEO_Location_ClockIn.SUCCESS, null));
      showErrorMessage('Geolocation Not Supported');      
    }
   geolocation.getCurrentPosition((position) => {            
      //  console.log('position..........',position)
       dispatch(actionCreator(appConfigActionTypes.get_GEO_Location_ClockIn.SUCCESS, position));
    }, (error) => {      
      dispatch(actionCreator(appConfigActionTypes.get_GEO_Location_ClockIn.SUCCESS, null));
      showErrorMessage('Geolocation permission denied',error);      
    },
    //(error) => console.log(new Date(), error),
    {maximumAge:600000, timeout:600000, enableHighAccuracy: true}    
    );
  };
};


export const getGeoLocationClockOut = () => {
  return (dispatch, getState) => {
    dispatch(actionCreator(appConfigActionTypes.get_GEO_Location_ClockOut.REQUEST));        
    const geolocation = navigator.geolocation;
    if (!geolocation) {      
      dispatch(actionCreator(appConfigActionTypes.get_GEO_Location_ClockOut.SUCCESS, null));
      showErrorMessage('Geolocation Not Supported');      
    }
   geolocation.getCurrentPosition((position) => {            
      //  console.log('position..........',position)
       dispatch(actionCreator(appConfigActionTypes.get_GEO_Location_ClockOut.SUCCESS, position));
    }, (error) => {      
      dispatch(actionCreator(appConfigActionTypes.get_GEO_Location_ClockOut.SUCCESS, null));
      showErrorMessage('Geolocation permission denied',error);      
    },
    //(error) => console.log(new Date(), error),
    {maximumAge:600000, timeout:600000, enableHighAccuracy: true}    
    );
  };
};

// export const getGeoLocation = () => {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(appConfigActionTypes.get_GEO_Location.REQUEST));        
//     // const geolocation = navigator.geolocation;
//     // if (!geolocation) {      
//     //   showErrorMessage('Geolocation Not Supported');
//     // }
//     // geolocation.getCurrentPosition((position) => {            
//        //dispatch(actionCreator(appConfigActionTypes.get_GEO_Location.SUCCESS, position));
//        dispatch(actionCreator(appConfigActionTypes.get_GEO_Location.SUCCESS, null));
//     // }, () => {      
//     //   showErrorMessage('Geolocation permission denied');
//     // },
//     // //(error) => console.log(new Date(), error),
//     // {enableHighAccuracy: true, timeout: 10000, maximumAge: 3000}
//     // );
//   };  
//};



// WEBPACK FOOTER //
// ./src/modules/AppConfig/actions/index.js